














































































































































































import { debounce } from 'debounce'
import { mapGetters } from 'vuex'
import Vue from 'vue'
import Person from '@/types/Person.interface'
import { Route } from 'vue-router'
import AppNavigationDrawerItem from '@/components/AppNavigationDrawerItem.vue'
import { popNewMessage } from '@/utility/helpers'
interface Item {
    title?: string
    appendSubtitle?: boolean
    subtitle?: string
    subtitleIcon?: string
    link?: string
    append?: boolean
    appendContent?: number
    appendColor?: string
    badge?: boolean
    badgeColor?: string
    badgeContent?: string
    badgeIcon?: string
    disabledPopup?: boolean
    icon?: string
    iconColor?: string
    iconTooltip?: string
    groupItem?: boolean
    id?: string
    idx?: number
    group?: boolean
    hidden?: boolean
    groupItems?: object[]
    callback?: Function
}
export default Vue.extend({
    components: { AppNavigationDrawerItem },
    props: {
        drawerIsMin: {
            type: Boolean,
            required: true,
            default: false
        }
    },
    data() {
        return {
            //  Array of our active nav groups
            activeNavs: [],
            // The last inbox route the user was on
            lastInboxRoute: null,
            //  A show more toggle for group items
            showActiveGroup: false
        }
    },
    mounted() {
        //  Set our active nav
        this.setActiveNav()
    },
    computed: {
        ...mapGetters([
            'defaultBucketUnreadCount',
            'groupsBuckets',
            'hasInvoices', 
            'isApp',
            'notificationsUnreadCount',
            'smsAccount',
            'storageLimit',
            'storageUsed',
            'tenant',
            'user'
        ]),
        A2PRegistered(): boolean {
            const a2pEnabled = this.$store.getters.settingGet('a2pEnabled')

            // Ensure that the value isn't null, if it is we don't return it
            return a2pEnabled != null
        },
        actionStyle(): object {
            //  Grab our margin style
            const marginStyle = { 'margin-right': '10px !important' }

            //  If our drawer is NOT minified then just return the margin style
            if (!this.drawerIsMin) return marginStyle

            //  Else, we have these so our icons appear nice n pretty
            return {
                'margin-left': '0px !important',
                'margin-right': '0px !important',
                'padding-left': '0px !important',
                width: '100%',
                display: 'flex',
                'justify-content': 'center',
                'align-items': 'center'
            }
        },
        approachingLimit(): boolean {
            //  Approaching limit is when you have 10% or less of your storage remaining
            //  Formula is (limit - used) being <= 10% of limit
            return this.storageLimit - this.storageUsed <= this.storageLimit * 0.1
        },
        // Items displayed in the bottom left corner of the client
        bottomItems(): Item[] {
            //  Get the unread notifications count
            const count = this.notificationsUnreadCount

            //  Return our list of items
            return [
                //  Commented out v2 waitlist option due to MCS request
                // {
                //     title: "You're invited",
                //     appendSubtitle: true,
                //     subtitle: "Click to join the 2.0 waitlist",
                //     subtitleIcon: 'mdi-creation',
                //     id: 'v2-invite',
                //     iconColor: 'primary',
                //     callback: () => {
                //         //  Takes user to v2 wait list sign up page
                //         const link = "https://www.messagedesk.com/version-2"

                //         //  Open link in new tab
                //         window.open(link, '_blank')
                //     },
                //     //  We cannot show this to users if we are on mobile since we cannot open a tab for them
                //     hidden: this.isApp
                // },
                {
                    title: 'Integrations',
                    icon: 'mdi-apps',
                    id: 'integrations',
                    link: '/integrations',
                    hidden: this.$vuetify.breakpoint.xsOnly
                },
                {
                    title: 'Team',
                    icon: 'mdi-account-multiple',
                    id: 'team-page-menu-select',
                    link: '/teammates'
                },
                {
                    title: 'Notifications',
                    icon: 'mdi-bell',
                    badge: count > 0,
                    badgeColor: 'red',
                    id: 'notifications-page-menu-select',
                    badgeContent: count > 99 ? '99+' : count,
                    callback: () => {
                        this.$store.dispatch('dialogOpen', {
                            type: 'APP',
                            component: 'notifications-button',
                            width: '550px'
                        })
                    }
                },
                {
                    title: 'Templates',
                    icon: 'mdi-format-size',
                    id: 'templates-page-menu-select',
                    link: '/templates'
                },
                {
                    title: 'Settings',
                    icon: 'mdi-cog',
                    id: 'settings-page-menu-select',
                    link: '/settings'
                },
                {
                    title: 'Help',
                    icon: 'mdi-help-circle',
                    id: 'help-button'
                }
            ]
        },
        //  The style applied to the drawer container
        containerStyle(): object {
            return {
                background: this.$colors.grey.lighten4,
                borders: '0px',
                height: '100%'
            }
        },
        drawerHeight(): number {
            //  Grab our content height
            const height = document.body.clientHeight

            //  Subtract the height of our top area
            const top = 68

            //  Return total
            return height - top
        },
        inboxGroupItems(): Item[] {
            //  Init. the navigation items to show up under 'Inbox'
            let groupItems = []

            //  If there are bucket groups loaded, create a route for them => /i/g/{groupId}
            if (this.groupsBuckets) {
                //  Sort by the order the user has set from the bucket form
                this.groupsBuckets.sort((x, y) => x.bucket?.order - y.bucket?.order)

                //  Iterate through all our groups
                for (let i = 0; i < this.groupsBuckets.length; i++) {
                    //  Reference to our current group
                    let curr = this.groupsBuckets[i]

                    //  Container for our item to be pushed
                    let item = {}

                    //  Determine item based on whether or not this is default
                    if (curr.name === 'All Contacts') {
                        item = {
                            //  For all conversations the logic is a bit different since the name is fixed, we base truncation on the number of unread notifications only, if our notifcations
                            //  are more than double digits we truncate the folder name to prevent the text overlapping 
                            title: curr.unread_count > 10 ? 'All Conversations'.slice(0, 14) + '...' : 'All Conversations',
                            link: '/inbox',
                            append: curr.unread_count > 0,
                            appendContent: curr.unread_count,
                            appendColor: 'primary',
                            icon: 'bi-circle-fill',
                            iconColor: 'primary',
                            iconTooltip: 'All Contacts',
                            groupItem: true
                        }
                    }
                    //  Else, push this group item
                    else {
                        item = {
                            //  If our group title is longer than 15 characters or we have double digit notifcations or more we truncate the rest of it and indicate that the name is truncated with 3 dots, slice does not modify in place so this doesn't affect the actual
                            //  group name in the DB, this prevents the append section of unread_count from overlapping on the name
                            title: curr.name.length > 14 || curr.unread_count > 10 ? curr.name.slice(0, 14) + '...' : curr.name,
                            link: `/i/g/${curr.id}`,
                            append: curr.unread_count > 0,
                            appendContent: curr.unread_count,
                            appendColor: 'primary',
                            icon: 'bi-circle-fill',
                            iconColor: curr.bucket?.color,
                            iconTooltip: curr.name,
                            groupItem: true
                        }
                    }

                    //  Push our item
                    groupItems[i] = item
                }
            }

            //  Push 'New Bucket' item last
            groupItems.push({
                title: 'Edit Views',
                callback: () => this.bucket(),
                icon: 'bi-pencil-fill',
                iconTooltip: 'Edit Views',
                disabled: this.groupsBuckets === null,
                groupItem: true
            })

            //  Return inbox group items
            return groupItems
        },
        navItems(): Item[] {
            return [
                {
                    title: `Inbox`,
                    icon: 'mdi-inbox',
                    id: 'inbox-page-menu-select',
                    link: '/inbox',
                    append: this.defaultBucketUnreadCount > 0,
                    appendContent: this.defaultBucketUnreadCount,
                    appendColor: 'primary',
                    idx: 0,
                    group: true,
                    groupItems: this.inboxGroupItems
                },
                {
                    title: `Broadcasts`,
                    icon: 'bi-megaphone-fill',
                    id: 'broadcasts-page-menu-select',
                    link: '/broadcasts'
                },
                {
                    title: 'Contacts',
                    icon: 'bi-person-lines-fill',
                    id: 'contacts-page-menu-select',
                    idx: 1,
                    group: true,
                    groupItems: [
                        {
                            title: 'All Contacts',
                            icon: 'mdi-account',
                            iconTooltip: 'All Contacts',
                            link: '/contacts',
                            groupItem: true
                        },
                        {
                            title: 'Groups',
                            icon: 'mdi-account-multiple',
                            iconTooltip: 'Groups',
                            link: '/groups',
                            groupItem: true
                        }
                    ]
                },
                {
                    title: 'Campaigns',
                    icon: 'mdi-sitemap',
                    id: 'campaigns-page-menu-select',
                    idx: 2,
                    group: true,
                    groupItems: [
                        {
                            title: 'Autoresponders',
                            icon: 'bi-lightning-fill',
                            iconTooltip: 'Autoresponders',
                            link: '/auto-responders',
                            groupItem: true
                        },
                        {
                            title: 'Office Hours',
                            icon: 'mdi-clock',
                            iconTooltip: 'Office Hours',
                            link: '/office-hours',
                            disabledPopup: this.operator,
                            groupItem: true
                        },
                        {
                            title: 'Forms',
                            icon: 'mdi-form-select',
                            iconTooltip: 'Forms',
                            link: '/forms',
                            disabledPopup: this.operator,
                            groupItem: true
                        },
                        {
                            title: 'Chatbot',
                            icon: 'bi-chat-square-fill',
                            iconTooltip: 'Chatbot',
                            link: '/chatbots',
                            disabledPopup: this.operator,
                            groupItem: true
                        }
                    ]
                },
                {
                    title: 'Payments',
                    icon: 'mdi-cash-multiple',
                    id: 'payments-page-menu-select',
                    link: '/payments',
                    hidden:
                        this.tenant.data_provider !== 'QBO' &&
                        this.tenant.data_provider !== 'XERO',
                    idx: 3,
                    group: true,
                    groupItems: [
                        {
                            title: 'Automations',
                            icon: 'bi-calendar-check',
                            link: '/payments',
                            info: this.isApp ? '' : 'Beta',
                            groupItem: true
                        },
                        {
                            title: 'Invoices',
                            icon: 'bi-cash',
                            link: '/invoices',
                            info: this.isApp ? '' : 'Beta',
                            groupItem: true
                        }
                    ]
                }
            ]
        },
        onHome(): boolean {
            //  Check our current route
            const route = this.$route.path

            //  If we are at home then return true
            if (route.includes('home')) return true

            //  Else, return false
            return false
        },
        operator(): boolean {
            //  Grab our current role
            const role = this.$store.getters.userRole(this.$store.getters.user)

            //  Check if this role is an operator
            return window.getProps(role, ['name']) === 'Operator'
        }
    },
    methods: {
        //  When the colored dot icon is clicked (next to an inbox bucket)
        async bucket(): Promise<void> {
            //  Open new bucket create/edit/remove form
            this.$store.dispatch('dialogOpen', {
                type: 'APP',
                title: 'Edit Views',
                help: 'https://learn.messagedesk.com/en/articles/5527921-multiple-inboxes-organize-conversations-at-scale-with-custom-views',
                icon: 'bi-inbox-fill',
                color: 'primary',
                component: 'new-bucket-form',
                titleStyles: { display: 'inline', 'max-width': 'fit-content' },
                props: {
                    bucketGroups: this.groupsBuckets
                },
                callback: async () => {
                    //  Re-paginate bucket groups after an update
                    this.$store.dispatch('groupsBucket')

                    //  Close the dialog
                    this.$store.dispatch('dialogClose', 'APP')
                }
            })
        },
        disabledPopup(): void {
            //  Open a dialog informing user they cannot
            this.$store.dispatch('dialogOpen', {
                type: 'MESSAGE',
                title: 'Access Disabled',
                text: "You don't have permission to access this feature. Please contact your account's admin to perform this task or have them update your account permission",
                icon: 'mdi-alert',
                color: 'primary',
                closeable: true
            })
        },
        //  When the activator list item for a group is clicked
        groupClick(item: Item): void {
            //  Check if this item is disabled
            const disabled = item.disabledPopup

            //  If it is, then pop our disabled dialog
            if (disabled) return this.disabledPopup()

            //  Set our active nav
            this.setActiveNav()

            if (item.title == 'Inbox') {
                if (this.$route.path == '/inbox' || this.$route.path.includes('/i/g/'))
                    return

                if (this.lastInboxRoute) return this.$router.push(this.lastInboxRoute)

                this.$router.push('/inbox')
            }
            //  Else, if the title is contacts then navigate to all contacts
            else if (item.title == 'Contacts') {
                //  Do nothing if we are already here
                if (this.$route.path == '/contacts') return

                //  Else, navigate
                this.$router.push('/contacts')
            }
        },
        goToQbo(): void {
            const url = process.env.VUE_APP_QBO_APP_URL
            window.open(url, this.$store.getters.isApp ? '_system' : '_blank')
        },
        goToXero(): void {
            const url = 'https://go.xero.com/Dashboard/'
            window.open(url, this.$store.getters.isApp ? '_system' : '_blank')
        },
        newMessage(): void {
            //  Route to inbox if we aren't already there
            if (!this.$route.path.includes('inbox')) this.$router.push('/inbox')

            //  Pop the new message
            popNewMessage()
        },
        //  Debounce to give time for reactivity of ref
        setActiveNav: debounce(function () {
            //  If our active navs is empty make sure we populate it
            this.activeNavs = this.$refs.listGroup.map((x) => x.isActive)
        }, 150),
        toggleDrawer(): void {
            this.$store.commit('appDrawerToggle')
        }
    },
    watch: {
        //  Wathch for route changes
        $route(value: Route): void {
            //  If the route is inbox or a bucket group
            if (value.path == '/inbox' || value.path.includes('/i/g/')) {
                //  Open the list item groups
                this.$refs.listGroup[0].isActive = true

                //  Set the last inbox path
                this.lastInboxRoute = value.path
            }
            //  Else set the list group to closed
            else {
                this.$refs.listGroup[0].isActive = false
            }

            //  Set our active nav
            this.setActiveNav()
        },
        drawerIsMin(bool: boolean): void {
            //  If we are collapsed, then close everything
            if (bool) this.$refs.listGroup.forEach((x) => (x.isActive = !bool))
            else {
                //  Find the idnex of our active nav menu group
                const active = this.activeNavs.findIndex((x) => x === true)

                //  If our index is -1 do nothing
                if (active === -1) return

                //  Set the same list group to be open (this is for the menu)
                this.$refs.listGroup[active].isActive = true
            }
        }
    }
})
